import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import GetProxy from "../../common/GetProxy";
import { handleResponseCode } from "../../../app/utilities/helpers";
import moment from "moment";

const proxy = GetProxy();
const cookies = new Cookies();

export const getIncComplianceStatusCountAPI = createAsyncThunk(
    "post/getIncComplianceStatusCountAPI",
    async (props) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const { payload } = props;
            const response = await fetch(`${proxy}/api/v1/sirarINC/getComplianceStatusCount`, {
                method: 'POST',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": apiToken,
                    USERNAME: username,
                },
                body: JSON.stringify(payload)
            });
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }
);

export const getIncTrendChartAPI = createAsyncThunk(
    "post/getIncTrendChartAPI",
    async (props) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const { payload } = props;
            const response = await fetch(`${proxy}/api/v1/sirarINC/getTrendChart`, {
                method: 'POST',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": apiToken,
                    USERNAME: username,
                },
                body: JSON.stringify(payload)
            });
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }
);

export const getIncNonCompliantByAppAPI = createAsyncThunk(
    "post/getIncNonCompliantByAppAPI",
    async (props) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const { payload } = props;
            const response = await fetch(`${proxy}/api/v1/sirarINC/getNonCompliantByApp`, {
                method: 'POST',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": apiToken,
                    USERNAME: username,
                },
                body: JSON.stringify(payload)
            });
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }
);

export const getIncFilterAPI = createAsyncThunk(
    "get/getIncFilterAPI",
    async () => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const response = await fetch(`${proxy}/api/v1/sirarINC/filter`, {
                method: 'GET',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": apiToken,
                    USERNAME: username,
                },
            });
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }
);

export const getIncReasonDetailsPopUpAPI = createAsyncThunk(
    "get/getIncReasonDetailsPopUpAPI",
    async (props) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const { incNumber, appCode } = props;
            const response = await fetch(`${proxy}/api/v1/sirarINC/getReasonDetailsPopUp/${incNumber}/${appCode}`, {
                method: 'GET',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": apiToken,
                    USERNAME: username,
                },
            });
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }
);

export const getIncServersListAPI = createAsyncThunk(
    "get/getIncServersListAPI",
    async (props) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const { incNumber } = props;
            const response = await fetch(`${proxy}/api/v1/sirarINC/getServersOrHostList/${incNumber}`, {
                method: 'GET',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": apiToken,
                    USERNAME: username,
                },
            });
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }
);

export const getIncListAPI = createAsyncThunk(
    "post/getIncListAPI",
    async (props) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const { pageNumber, itemsPerPage, payload } = props;
            const response = await fetch(`${proxy}/api/v1/sirarINC/list/${pageNumber}/${itemsPerPage}`, {
                method: 'POST',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": apiToken,
                    USERNAME: username,
                },
                body: JSON.stringify(payload)
            });
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }
);

const initialState = {
    selectedFiltersData: {
        selectedDate: {
            timePicker: false,
            maxDate: moment().toDate(),
            autoApply: true,
            startDate: moment().startOf("month").format('YYYY-MM-DDT00:00:00.000'),
            endDate: moment().add(1, 'day').startOf('day').format('YYYY-MM-DDT00:00:00.000'),
            locale: {
                format: 'DD/MM/YYYY',
            },
        },
        selectedDivision: [],
        selectedApplication: [],
    },
    incFilterData: [],
    incFilterLoading: false,
    activeTabKey: "NonCompliantFindings",
    tablereload: false,

    incComplianceStatusData: [],
    incComplianceStatusLoading: false,

    incTrendChartData: [],
    incTrendChartLoading: false,

    incNonCompliantByAppData: [],
    incNonCompliantByAppLoading: false,

    incListData: [],
    incListLoading: false,

    error: false,
};

export const IncSlice = createSlice({
    name: "IncSlice",
    initialState,
    reducers: {
        resetIncSliceData: () => {
            return initialState;
        },
        setIncSelectedFiltersData: (state, action) => {
            state.selectedFiltersData = action.payload;
        },
        setIncActiveTabKey: (state, action) => {
            state.activeTabKey = action.payload;
        },
        setIncTableReload: (state, action) => {
            state.tablereload = action.payload;
        },
        setIncTableData: (state, action) => {
            state.incListData = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            // getIncFilterAPI
            .addCase(getIncFilterAPI.pending, (state) => {
                state.incFilterLoading = true;
                state.error = false;
            })
            .addCase(getIncFilterAPI.fulfilled, (state, action) => {
                state.incFilterData = action.payload;
                state.incFilterLoading = false;
                state.error = false;
            })
            .addCase(getIncFilterAPI.rejected, (state) => {
                state.incFilterLoading = false;
                state.incFilterData = [];
                state.error = true;
            })

            // getIncComplianceStatusCountAPI
            .addCase(getIncComplianceStatusCountAPI.pending, (state) => {
                state.incComplianceStatusLoading = true;
                state.error = false;
            })
            .addCase(getIncComplianceStatusCountAPI.fulfilled, (state, action) => {
                state.incComplianceStatusData = action.payload;
                state.incComplianceStatusLoading = false;
                state.error = false;
            })
            .addCase(getIncComplianceStatusCountAPI.rejected, (state) => {
                state.incComplianceStatusLoading = false;
                state.incComplianceStatusData = [];
                state.error = true;
            })

            // getIncTrendChartAPI
            .addCase(getIncTrendChartAPI.pending, (state) => {
                state.incTrendChartLoading = true;
                state.error = false;
            })
            .addCase(getIncTrendChartAPI.fulfilled, (state, action) => {
                state.incTrendChartData = action.payload;
                state.incTrendChartLoading = false;
                state.error = false;
            })
            .addCase(getIncTrendChartAPI.rejected, (state) => {
                state.incTrendChartLoading = false;
                state.incTrendChartData = [];
                state.error = true;
            })

            // getIncNonCompliantByAppAPI
            .addCase(getIncNonCompliantByAppAPI.pending, (state) => {
                state.incNonCompliantByAppLoading = true;
                state.error = false;
            })
            .addCase(getIncNonCompliantByAppAPI.fulfilled, (state, action) => {
                state.incNonCompliantByAppData = action.payload;
                state.incNonCompliantByAppLoading = false;
                state.error = false;
            })
            .addCase(getIncNonCompliantByAppAPI.rejected, (state) => {
                state.incNonCompliantByAppLoading = false;
                state.incNonCompliantByAppData = [];
                state.error = true;
            })

            // getIncListAPI
            .addCase(getIncListAPI.pending, (state) => {
                state.incListLoading = true;
                state.error = false;
            })
            .addCase(getIncListAPI.fulfilled, (state, action) => {
                state.incListData = action.payload;
                state.incListLoading = false;
                state.error = false;
            })
            .addCase(getIncListAPI.rejected, (state) => {
                state.incListLoading = false;
                state.incListData = [];
                state.error = true;
            });
    }
});

export const {
    resetIncSliceData,
    setIncSelectedFiltersData,
    setIncActiveTabKey,
    setIncTableReload,
    setIncTableData,
} = IncSlice.actions;

export default IncSlice.reducer;
